<template>
  <div style="display: flex">
    <svg
      :data-testid="testid"
      :class="className"
      xmlns="http://www.w3.org/2000/svg"
      v-bind="$attrs"
    >
      <title v-if="title">
        {{ title }}
      </title>
      <use :xlink:href="iconPath" xmlns:xlink="http://www.w3.org/1999/xlink" />
    </svg>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

interface Props {
  name: string;
  title?: string | null;
}

const props = withDefaults(defineProps<Props>(), {
  title: null,
});

const testid = computed(() => `icon-${props.name}`);
const iconPath = computed(() => `#${props.name}`);
const className = computed(() => `svg-icon svg-icon--${props.name}`);
</script>
